<footer class="site-footer footer-dark">

    <div class="sx-f-nl-section">
        <div class="container">
            <div class="row">
                <div class="col-lg-6 col-md-12">
                    <h2 class="sx-f-title">
                        {{ (lang.lang$ | async) === 'ar' ? 'اشترك في نشرتنا البريدية' : 'Subscribe to our newsletter.' }}
                    </h2>
                </div>
                <div class="col-lg-6 col-md-12">
                    <div class="sx-nl-form">
                        <form (ngSubmit)="subscribe()" *ngIf="!nlDone">
                            <!-- honeypot: hidden from users; bots that fill it are silently dropped -->
                            <input type="text" name="nlWebsite" [(ngModel)]="nlWebsite" tabindex="-1" autocomplete="off"
                                   aria-hidden="true" style="position:absolute;left:-9999px;width:1px;height:1px;opacity:0">
                            <div class="sx-nl-form-inner">
                                <input type="email" name="nlEmail" class="sx-nl-form-input"
                                       [(ngModel)]="nlEmail" [disabled]="nlSending"
                                       [attr.placeholder]="(lang.lang$ | async) === 'ar' ? 'بريدك الإلكتروني' : 'Your email address'">
                                <button type="submit" class="sx-nl-form-btn" [disabled]="nlSending" [attr.aria-label]="(lang.lang$ | async) === 'ar' ? 'اشترك' : 'Subscribe'">
                                    <i class="flaticon-back-left"></i>
                                </button>
                            </div>
                        </form>
                        <p *ngIf="nlError" class="mm-nl-msg mm-nl-err">{{ nlError }}</p>
                        <p *ngIf="nlDone" class="mm-nl-msg mm-nl-ok">
                            {{ (lang.lang$ | async) === 'ar' ? 'شكراً لاشتراكك!' : 'Thanks for subscribing!' }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- FOOTER BLOCKES START -->
    <div class="footer-top">
        <div class="container">
            <div class="row">
                <!-- ABOUT COMPANY -->
                <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6">
                    <div class="widget widget_about">
                        <div class="logo-footer clearfix p-b15">
                            <a routerLink="/index" class="sx-text-primary"><img src="assets/images/Logo-light.png"
                                    alt="image"></a>
                        </div>
                        <p> New Maven Merge is a technology solutions company specializing in ERP software systems, IT
                            devices, and complete computer & technology supplies. We help businesses streamline
                            operations, improve efficiency, and achieve digital transformation through smart, reliable,
                            and scalable solutions tailored to their needs.
                        </p>
                        <div class="widget_about-call-section">
                            <div class="sx-f-call-icon"><i class="flaticon-telephone"></i></div>
                            <div class="sx-f-call-section">
                                <span>Contact us 24/7</span>
                                <a [href]="'tel:' + get('contact.phone', '+201026691116')">{{ get('contact.phone', '+ 20 1026691116') }}</a>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- EXPLORE LINKS -->
                <div class="col-xl-2 col-lg-3 col-md-6 col-sm-6 col-6 col">

                    <div class="widget widget_services">
                        <h4 class="sx-f-title">Explore Links</h4>
                        <ul>
                            <li><a routerLink="/itsolutions/services">Our Services</a></li>
                            <li><a routerLink="/company/team">Meet Our Team</a></li>
                            <li><a routerLink="/itsolutions/portfolio/1">Our Portfolio</a></li>
                            <li><a routerLink="/company/contact">Contact</a></li>
                            <li><a routerLink="/itblogs/blogs/grid">News</a></li>
                        </ul>
                    </div>
                </div>

                <!-- USEFUL LINK -->
                <div class="col-xl-2 col-lg-3 col-md-6 col-sm-6 col-6 col">

                    <div class="widget widget_services">
                        <h4 class="sx-f-title">Useful Links</h4>
                        <ul>
                            <li><a routerLink="/itsolutions/mission">Mission &amp; Vision</a></li>
                            <li><a routerLink="/company/why-choose-us">Why Choose Us</a></li>
                            <li><a routerLink="/itsolutions/portfolio/1">Portfolio</a></li>
                            <li><a routerLink="/itsolutions/portfolio/2">Case Studies</a></li>
                            <li><a routerLink="/itsolutions/portfolio/detail">Case Studies V2</a></li>
                        </ul>
                    </div>
                </div>

                <!-- SOLUTIONS -->
                <div class="col-xl-2 col-lg-6 col-md-6 col-sm-6 col-12 col footer-col-3">
                    <div class="widget widget_info">
                        <h4 class="sx-f-title">Solutions</h4>
                        <ul>
                            <li>
                                <div class="widget-info-icon">
                                    <i class="flaticon-phone"></i>
                                </div>
                                <div class="widget-info-detail">
                                    <a [href]="'tel:' + get('contact.phone', '+201026691116')">{{ get('contact.phone', '+ 20 1026691116') }}</a>
                                    <!-- <a href="tel:+55(66633)2577">+ 55 ( 66633 ) 25 77</a> -->
                                </div>
                            </li>
                            <li>
                                <div class="widget-info-icon">
                                    <i class="flaticon-email"></i>
                                </div>
                                <div class="widget-info-detail">
                                    <p><a [href]="'mailto:' + get('contact.email', 'contactus@maven-merge.com')">{{ get('contact.email', 'contactus@maven-merge.com') }}</a></p>
                                </div>
                            </li>

                            <li>
                                <div class="widget-info-icon">
                                    <i class="flaticon-maps-and-flags"></i>
                                </div>
                                <div class="widget-info-detail">
                                    <p>{{ address('Office No. (A-23-01), Plot No. 298, Second Sector, New Cairo (Fifth Settlement), Cairo Governorate') }}</p>
                                </div>


                            </li>
                        </ul>
                    </div>
                </div>

                <!-- CONTACT US -->
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                    <div class="widget widget_insta-gallery">
                        <h4 class="sx-f-title">Instagram</h4>
                        <ul>
                            <li>
                                <div class="sx-f-insta">
                                    <a href="https://www.instagram.com/">
                                        <img src="assets/images/f-insta/pic1.jpg" alt="Image">
                                        <i class="feather-instagram"></i>
                                    </a>
                                </div>
                            </li>
                            <li>
                                <div class="sx-f-insta">
                                    <a href="https://www.instagram.com/">
                                        <img src="assets/images/f-insta/pic2.jpg" alt="Image">
                                        <i class="feather-instagram"></i>
                                    </a>
                                </div>
                            </li>
                            <li>
                                <div class="sx-f-insta">
                                    <a href="https://www.instagram.com/">
                                        <img src="assets/images/f-insta/pic3.jpg" alt="Image">
                                        <i class="feather-instagram"></i>
                                    </a>
                                </div>
                            </li>
                            <li>
                                <div class="sx-f-insta">
                                    <a href="https://www.instagram.com/">
                                        <img src="assets/images/f-insta/pic4.jpg" alt="Image">
                                        <i class="feather-instagram"></i>
                                    </a>
                                </div>
                            </li>
                            <li>
                                <div class="sx-f-insta">
                                    <a href="https://www.instagram.com/">
                                        <img src="assets/images/f-insta/pic5.jpg" alt="Image">
                                        <i class="feather-instagram"></i>
                                    </a>
                                </div>
                            </li>
                            <li>
                                <div class="sx-f-insta">
                                    <a href="https://www.instagram.com/">
                                        <img src="assets/images/f-insta/pic6.jpg" alt="Image">
                                        <i class="feather-instagram"></i>
                                    </a>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>

            </div>
        </div>



    </div>

    <div class="sx-f-bottom-section">
        <div class="sx-f-social">
            <ul>
                <li *ngIf="get('social.facebook', 'https://www.facebook.com/')">
                    <a [href]="get('social.facebook', 'https://www.facebook.com/')" target="_blank">
                        <i class="flaticon-facebook"></i>
                    </a>
                </li>
                <li *ngIf="get('social.twitter', 'https://twitter.com/')">
                    <a [href]="get('social.twitter', 'https://twitter.com/')" target="_blank">
                        <i class="flaticon-twitter"></i>
                    </a>
                </li>
                <li *ngIf="get('social.linkedin', 'https://www.linkedin.com/')">
                    <a [href]="get('social.linkedin', 'https://www.linkedin.com/')" target="_blank">
                        <i class="flaticon-linkedin"></i>
                    </a>
                </li>
                <li *ngIf="get('social.instagram', 'https://www.instagram.com/')">
                    <a [href]="get('social.instagram', 'https://www.instagram.com/')" target="_blank">
                        <i class="flaticon-instagram"></i>
                    </a>
                </li>
            </ul>
        </div>
        <div class="sx-f-copy">
            © {{ year }} <a routerLink="/index">New Maven Merge</a>. {{ (lang.lang$ | async) === 'ar' ? 'جميع الحقوق محفوظة.' : 'All rights reserved.' }}
        </div>
    </div>
    <!-- FOOTER COPYRIGHT -->
</footer>